module.exports = __webpack_public_path__ + "static/media/Doordash-Large.5ed41036.png";